(function () {
  'use strict';

  var PRODUCT_URL_RE = /\/products\/([^?#/]+)/;
  var htmlCache = new Map();

  function fetchHtml(url) {
    if (!htmlCache.has(url)) {
      htmlCache.set(url, fetch(url).then(function (r) { return r.text(); }));
    }
    return htmlCache.get(url);
  }

  // El variant-picker heredado de la página de producto usa context="main_product",
  // lo que añade &section_id=X al fetch de re-render. Shopify devuelve ese endpoint
  // en formato JSON, pero createContextualFragment lo trata como HTML, deepQuerySelector
  // no encuentra el variant-picker y selectCombination falla sin actualizar form.id.value.
  // Cambiando a context="quick_buy" el fetch omite section_id y devuelve HTML completo.
  function fixVariantPicker(vp) {
    vp.setAttribute('context', 'quick_buy');
    vp.removeAttribute('update-url');
  }

  class ProductFullModal extends HTMLElement {
    show() {
      if (!this._dialog) this._buildDialog();
      this._dialog.showModal();
      if (!this._loaded) this._load();
    }

    close() {
      if (this._dialog) this._dialog.close();
    }

    _buildDialog() {
      var dialog = document.createElement('dialog');
      dialog.className = 'pfm-dialog';

      var closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'pfm-dialog__close';
      closeBtn.setAttribute('aria-label', 'Close');
      closeBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M6 6 18 18M6 18 18 6"/></svg>';

      var body = document.createElement('div');
      body.className = 'pfm-dialog__body';
      body.innerHTML = '<div class="pfm-dialog__loader"></div>';

      var self = this;

      closeBtn.addEventListener('click', function () { self.close(); });

      // Cerrar al hacer click en el backdrop
      dialog.addEventListener('click', function (e) { if (e.target === dialog) self.close(); });

      // Cerrar cuando se añade al carrito (para que el drawer aparezca encima)
      document.addEventListener('variant:add', function () { self.close(); });

      // Sincronizar variante: cuando el usuario cambia una opción, actualiza input[name="id"]
      // directamente vía DOMParser (fiable en todos los browsers, incluyendo Safari donde
      // createContextualFragment con HTML completo no permite que deepQuerySelector funcione)
      var pfmSeq = 0;
      body.addEventListener('change', function (e) {
        if (!e.target.matches('input[data-option-position]')) return;
        var handle = self.getAttribute('handle');
        if (!handle) return;
        var formEl = self._body.querySelector('form[action*="/cart/add"]');
        if (!formEl) return;
        var optionValues = Array.from(formEl.elements)
          .filter(function (el) { return el.getAttribute('data-option-position') && el.checked; })
          .sort(function (a, b) {
            return parseInt(a.getAttribute('data-option-position')) - parseInt(b.getAttribute('data-option-position'));
          })
          .map(function (el) { return el.value; });
        if (!optionValues.length) return;
        var seq = ++pfmSeq;
        var pfmRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(pfmRoot + 'products/' + handle + '?option_values=' + optionValues.join(','))
          .then(function (r) { return r.text(); })
          .then(function (html) {
            if (seq !== pfmSeq) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var formId = formEl.getAttribute('id');
            var vp = null;
            var vps = doc.querySelectorAll('variant-picker');
            for (var i = 0; i < vps.length; i++) {
              if (vps[i].getAttribute('form-id') === formId) { vp = vps[i]; break; }
            }
            if (!vp) return;
            var variantData = JSON.parse((vp.querySelector('script[data-variant]') || {}).textContent || '{}');
            if (!variantData.id) return;
            var idInput = formEl.querySelector('input[name="id"]');
            if (idInput) {
              idInput.value = variantData.id;
              idInput.disabled = false;
            }
          })
          .catch(function () {});
      });

      // Interceptar clicks en links de producto dentro del modal
      body.addEventListener('click', function (e) {
        var link = e.target.closest('a[href]');
        if (!link) return;
        var href = link.getAttribute('href');
        var match = href && href.match(PRODUCT_URL_RE);
        if (!match) return;
        e.preventDefault();
        var newHandle = match[1];
        // Si es el mismo producto, no hacer nada
        if (newHandle === self.getAttribute('handle')) return;
        // Cargar el nuevo producto en el mismo modal
        self._loaded = false;
        self.setAttribute('handle', newHandle);
        self._body.innerHTML = '<div class="pfm-dialog__loader"></div>';
        self._load();
      });

      dialog.appendChild(closeBtn);
      dialog.appendChild(body);
      document.body.appendChild(dialog);

      this._dialog = dialog;
      this._body = body;
    }

    _load() {
      var self = this;
      var handle = this.getAttribute('handle');
      if (!handle) return;

      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var url = root + 'products/' + handle;

      fetchHtml(url).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('.shopify-section--main-product');
        if (!section) return;

        var sectionId = section.id;
        var styleNodes = Array.from(doc.querySelectorAll('style')).filter(function (s) {
          return s.textContent.indexOf(sectionId) !== -1;
        });

        self._body.innerHTML = '';
        styleNodes.forEach(function (s) {
          var el = document.createElement('style');
          el.textContent = s.textContent;
          self._body.appendChild(el);
        });

        // Modificar el clon ANTES de conectarlo al DOM
        var sectionClone = section.cloneNode(true);
        sectionClone.querySelectorAll('product-gallery[allow-zoom]').forEach(function (g) {
          g.removeAttribute('allow-zoom');
        });
        sectionClone.querySelectorAll('open-lightbox-button').forEach(function (b) {
          b.remove();
        });
        // Fijar variant-pickers antes de conectar al DOM
        sectionClone.querySelectorAll('variant-picker').forEach(fixVariantPicker);

        self._body.appendChild(sectionClone);

        // ProductRerender puede reemplazar variant-picker tras un cambio de variante;
        // observamos el body para aplicar fixVariantPicker a cualquier nuevo elemento.
        if (self._rerenderObserver) self._rerenderObserver.disconnect();
        self._rerenderObserver = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
              if (node.nodeType !== 1) return;
              var vps = node.tagName === 'VARIANT-PICKER'
                ? [node]
                : Array.from(node.querySelectorAll('variant-picker'));
              vps.forEach(fixVariantPicker);
            });
          });
        });
        self._rerenderObserver.observe(self._body, { childList: true, subtree: true });

        if (window.Shopify && window.Shopify.PaymentButton) {
          window.Shopify.PaymentButton.init();
        }

        self._loaded = true;
      }).catch(function (err) {
        console.error('[product-full-modal]', err);
      }).finally(function () {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      });
    }
  }

  if (!customElements.get('product-full-modal')) {
    customElements.define('product-full-modal', ProductFullModal);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[aria-controls]');
    if (!trigger) return;
    var modal = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!(modal instanceof ProductFullModal)) return;
    event.preventDefault();
    modal.show();
  });
})();
